export default __webpack_public_path__ + "images/appstore-textbook.c38ed9d9.png";